import React from "react";
import { Outlet } from "react-router-dom";
import { authActions } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/slice";
import { useAppDispatch } from "../../../../business.InterfaceLayer/store/services/hooks.service/redux.hook";
import {
	LOCALSTORAGE_METHODS,
	localStorageService,
} from "../../../../general/utils/local-storage.service";
import { AUTH_FIELDS } from "../../../../business.InterfaceLayer/store/entities/auth.entity/redux/fields";

const InitializationStore = () => {
	const tokenAccess = localStorageService(LOCALSTORAGE_METHODS.GET, {
		key: AUTH_FIELDS.TOKEN_ACCESS,
	});
	const tokenRefresh = localStorageService(LOCALSTORAGE_METHODS.GET, {
		key: AUTH_FIELDS.TOKEN_REFRESH,
	});
	const isNeedChange = localStorageService(LOCALSTORAGE_METHODS.GET, {
		key: AUTH_FIELDS.IS_NEED_CHANGE,
	});
	const dispatch = useAppDispatch();

	dispatch(
		authActions.login({
			[AUTH_FIELDS.TOKEN_ACCESS]: tokenAccess || null,
			[AUTH_FIELDS.TOKEN_REFRESH]: tokenRefresh || null,
			[AUTH_FIELDS.IS_NEED_CHANGE]: isNeedChange || null,
			[AUTH_FIELDS.ROLE]: null,
			[AUTH_FIELDS.USER_ID]: null,
		})
	);

	return <Outlet />;
};

export default InitializationStore;
